import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import TagsAnchorContainer from "../TagsAnchorContainer";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicSecurisation = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Sécurité du compte', link: '/topics/compte/securite'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Nous travaillons en permanence à la sécurité de votre compte. Toutefois, voici quelques conseils pour protéger vos informations.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part mb-24">{anchorsParts[0].content}</p>
              <p className="help-text">
                <strong>Commencez par un mot de passe sûr :</strong> votre mot de passe Wodzone doit être unique et de préférence, entièrement différent de celui que vous 
                utilisez sur un autre compte, que ce soit votre adresse e-mail, vos comptes sur les réseaux sociaux ou votre banque. De cette façon, 
                si la sécurité de l'un des comptes est compromise, le risque est moins important pour les autres. Découvrez comment 
                <a target='_blank' className="link" href="/topics/compte/8">modifier votre mot de passe</a>ou
                <a target='_blank' className="link" href="/topics/compte/18">créer un mot de passe fiable.</a>
              </p>
              <p className="help-text">
                <strong>Signalez les éléments suspects :</strong> si vous avez des doutes quant à un event, un e-mail Wodzone, faites un
                <a target='_blank' className="link" href="https://www.wodzone.com/report-phishing.">signalement</a>afin qu'un contrôle soit effectué. 
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-24">{anchorsParts[1].content}</p>
              <p className="help-text">
                <strong>Repérez la mention « https » :</strong> au début d'une URL, cela signifie que votre connexion est cryptée, l'intégrité et la confidentialité de 
                vos données sont donc protégées. Certains navigateurs peuvent également afficher une icône représentant un cadenas à côté de l'URL 
                pour indiquer qu'elle est sécurisée. Pour commencer, saisissez <strong>https://www.wodzone.com</strong> directement 
                dans votre navigateur. Si vous cliquez sur un lien dans un e-mail, vérifiez l'URL de destination avant de vous connecter.
              </p>
              <p className="help-text">
                <strong>Maintenez vos logiciels à jour : </strong>vérifiez si des mises à jour sont disponibles pour minimiser les risques de sécurité. 
              </p>
              <p className="help-text">
                <strong>Installez un antivirus de confiance : </strong>cela vous aidera à détecter, prévenir et supprimer les virus courants, ainsi que d'autres types de cyberattaques. 
              </p>
              <p className="help-text">
                <strong>Vérifiez l'expéditeur : </strong>ne cliquez pas sur des liens et ne téléchargez pas de pièces jointes d'un e-mail si vous ne savez pas qui l'a envoyé.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part mb-24">{anchorsParts[2].content}</p>
              <p className="help-text">
                <strong>Passez toujours par Wodzone : </strong>effectuez tous vos paiements sur la plate-forme Wodzone. 
                Ne transférez pas d'argent en dehors de Wodzone et ne communiquez pas votre adresse e-mail. 
                Si quelqu'un vous envoie un e-mail vous demandant de payer ou d'accepter un paiement en dehors du site, 
                <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>contactez Wodzone</a>immédiatement. 
                Découvrez comment repérer les <a target='_blank' className="link" href="/topics/compte/16">e-mails qui ne proviennent pas de Wodzone.</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicSecurisation